export default "__VITE_ASSET__czIxYarR__"